
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import OurStory from './components/OurStory';
import VisionMission from './components/VisionMission';
import WhyChooseUs from './components/WhyChooseUs';
import FounderMessage from './components/FounderMessage';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutHero />
        <OurStory />
        <VisionMission />
        <WhyChooseUs />
        <FounderMessage />
      </main>
      <Footer />
    </div>
  );
}
